import React from "react";
import logo from "../../assets/logo.png";
import { FooterLinksLocal } from "./footer.links.local";
import { FooterLinks } from "./footer.links";

export const FooterMobile: React.FC<any> = () => {
  return (
    <div className="footer-mobile">
      <FooterLinksLocal />
      <FooterLinks />
      <img src={logo} className="footer-links-logo" />
    </div>
  );
};
